import {useState}from 'react';
import DropDownButton from 'devextreme-react/drop-down-button';
import '../../LibretaTareas/LibretaTareas.scss'
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import * as lbActions from '../../../reduxStore/LibretaTareas/LB_actions';
import * as nfActions from '../../../reduxStore/NewForms/NF_actions';
import * as Fnctn from '../../../contexts/GenericFunctions';
import { Popup, Tooltip } from 'devextreme-react';
import NewForm from '../NewForm/NewForm'
import { halcoloaderActive, halcoloaderRemove } from '../../../contexts/HalcoLoader';

interface IProps {
    prop: any,
    deleteCourse: (courseId:string) => void
}

function CourseItem({ prop, deleteCourse  }: IProps){
    const [visiblePopUp, setvisiblePopUp] = useState<boolean>(false);
    const [ItemsMenu, setItemsMenu] = useState<any>([
        { id: 1, name: 'Editar tarea', icon: 'edit' },
        { id: 2, name: 'Eliminar tarea', icon: 'close' }
    ]);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const nav = async (navigate: any, dispatch: any, objcourse: any) => {
        halcoloaderActive();
        if(Fnctn.NullUndefinedEmpty(objcourse.evaluation_id)) objcourse.evaluation_id = null;

        dispatch(lbActions.set_tarea_id(objcourse._id));
        dispatch(lbActions.set_tarea_titulo(objcourse.title));
        dispatch(lbActions.set_tarea_img(objcourse.icon_path));
        dispatch(lbActions.set_tarea_imgname(objcourse.icon_name));
        dispatch(lbActions.set_tarea_contenido(objcourse.content));
        dispatch(lbActions.set_tarea_vencimiento(objcourse.has_expiration));
        dispatch(lbActions.set_tarea_cantidad(objcourse.expiration_amount));
        dispatch(lbActions.set_tarea_tiempo(objcourse.expiration_time));
        dispatch(lbActions.set_tarea_secuencia(objcourse.expiration_sequence));
        dispatch(lbActions.set_tarea_categoria(objcourse.category_id));
        dispatch(lbActions.set_tarea_notificacion(objcourse.send_notification));
        dispatch(lbActions.set_tarea_autoasignacion(objcourse.autoAssign));
        dispatch(lbActions.set_tarea_tipoasignacion(objcourse.type_assignment));
        dispatch(lbActions.set_tarea_segmentacion(objcourse.segmentation));
        dispatch(lbActions.set_tarea_segmentacionType(objcourse.segmentation_type));
        dispatch(lbActions.set_tarea_from(objcourse.from));
        dispatch(lbActions.set_tarea_to(objcourse.to));
        dispatch(lbActions.set_tarea_evaluation_id(objcourse.evaluation_id));
        dispatch(lbActions.set_tarea_attachments(objcourse.attachments));
        dispatch(lbActions.set_tarea_order(objcourse.order));
        dispatch(lbActions.set_tarea_diasnotificacionvencimiento(objcourse.expiration_days_notification));
        dispatch(lbActions.set_tarea_tipo_tarea(objcourse.task_type));
        await navigate('/tasks');
        halcoloaderRemove();
    }

    const ViewForm = async (navigate:any, dispatch: any, objcourse: any) => {
        halcoloaderActive();
        let dtcourse = await Fnctn.postData(`/training/evaluations/${objcourse.evaluation_id}`, "GET", {});
        let dtForm = await dtcourse.json();
        let questions:any = dtForm.data[0].questionnaire[0].questions;

        dispatch(nfActions.set_form_id(dtForm.data[0]._id));
        dispatch(nfActions.set_form_name(objcourse.title));
        dispatch(nfActions.set_form_returnview("/LibretaTareas"));
        dispatch(nfActions.set_form_questions(questions));
        dispatch(nfActions.set_type_form("L"));
        await navigate('/Cuestionario');
        halcoloaderRemove();
    }

    const addFormcourse = () => {
        setvisiblePopUp(true);
    }

    

    const onItemClick = async (opcion: number, id_course: string) => {
        switch (opcion) {
            case 1:
                nav(navigate, dispatch, prop);
                break
            case 2: 
                Deletecourse(id_course);
                break
            case 3:
                addFormcourse();
                
                break
            case 4:
                ViewForm(navigate, dispatch, prop);
                break
        }
    };
    
    const OpcionesRender = (e:any) => {
        const icon = `dx-icon dx-icon-${e.icon}`;
        return (
            <div style={{width:"0rem", height:"0rem"}}>
                <i className={icon} style={{fontSize:"20px"}}></i>
                <label style={{margin: "auto auto auto 1rem"}}>{e.name}</label>
            </div>
        );
    }

    const EditOpiones = () => {
        if (Fnctn.NullUndefinedEmpty(prop.evaluation_id)){
            setItemsMenu((prevstatus:any) => [...prevstatus, {id: 3, name: 'Asociar cuestionario', icon: 'ordersbox'}]);
        }
        else{
            setItemsMenu((prevstatus:any) => [...prevstatus, {id: 4, name: 'Ver cuestionario', icon: 'taskhelpneeded'}]);
        }
    }

    const handlePopupHidden = () => {
        setvisiblePopUp(false);
    }

    const renderPopup = () => {
        let PropiedadesForm = { _idTarea: prop._id }
        return <NewForm props={PropiedadesForm} ></NewForm>
    }

    const Deletecourse = async (id_course: string) => {
        let Objt = { "active": false }

        await Fnctn.postData(`/training/task/${id_course}`, "PUT", Objt);
        await deleteCourse(id_course);
    }

    const CuestionarioAsociado = () => {
        let icon:any = null;

        if (!Fnctn.NullUndefinedEmpty(prop.evaluation_id)){
            let classString = `dx-icon dx-icon-taskcomplete IconFormularioAsociado`;
            let id = "IdCourse_" + prop._id;
            icon = <>
                <i className={classString} id={id}></i>
                <Tooltip
                    target={`#${id}`}
                    showEvent="mouseenter"
                    hideEvent="mouseleave"
                    hideOnOutsideClick={false}
                >
                    <label>Cuestionario Asociado</label>
                </Tooltip>
            </>
        }
        return (icon);
    }
    return (
        <div>
            <div className='listCategoriesContent'>
                <img src={prop.icon_path} alt='Imagen de categoría' className='ImgCategories' />
                <label className='lbTitleCategories'>{prop.title}</label>
                {CuestionarioAsociado()}
                <DropDownButton
                    className='menuTasks'
                    splitButton={false}
                    useSelectMode={false}
                    icon="overflow"
                    showArrowIcon={false}
                    items={ItemsMenu}
                    displayExpr="name"
                    keyExpr="id"
                    dropDownOptions={{ width: "15rem" }}
                    onItemClick={(e) => onItemClick(e.itemData.id, prop._id)}
                    itemRender={(e) => OpcionesRender(e)}
                    onInitialized={() => EditOpiones()}
                />
            </div>
            <Popup
                width={"40rem"}
                height={"15rem"}
                showTitle={false}
                dragEnabled={false}
                hideOnOutsideClick={true}
                visible={visiblePopUp}
                onHiding={handlePopupHidden}
                contentRender={renderPopup}
                showCloseButton={false}
                resizeEnabled={true}
            />
        </div>
    );
}
export default CourseItem;